export default __webpack_public_path__ + "static/media/2.5ecf46ca.png";